import React, { useEffect, useState } from 'react';
import * as func from "../../common/athleteCommon/FunctionCalls";
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import ImageWithBasePath from '../../../core/data/img/ImageWithBasePath';

const ExternalCompetitions = () => {

    const [compList, setCompList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchEvents() {
            setIsLoading(true);
            const compResponse = await func.externalCompetitions(null);
            setCompList(Array.isArray(compResponse) ? compResponse : [])
            setIsLoading(false);
        }
        fetchEvents();
    }, [])

    const filteredData = compList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const competitionRender = (rowData) => {
        return <span>{rowData.extComEventName}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.sportName}</span>;
    };

    const categoryRender = (rowData) => {
        return <span>{rowData.categoryName}</span>;
    };

    const levelRender = (rowData) => {
        return <span>{rowData.levelName}</span>;
    }

    const genderRender = (rowData) => {
        return <span>{rowData.genderName}</span>;
    }

    const formatRender = (rowData) => {
        return <span>{rowData.formatName}</span>;
    }

    const startDateRender = (rowData) => {
        return <span>{formatDate(rowData.extComEventStartDate)}</span>;
    }

    const endDateRender = (rowData) => {
        return <span>{formatDate(rowData.extComEventEndDate)}</span>;
    }

    const locationRender = (rowData) => {
        return <span>{rowData.extComEventLocation}</span>;
    }

    const countryRender = (rowData) => {
        return <span>{rowData.countryName}</span>;
    }

    const remarksRender = (rowData) => {
        return <span>{rowData.extcomRemarks}</span>;
    }

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventName"
                                                header="Competiton"
                                                body={competitionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportName"
                                                header="Sport"
                                                body={sportRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="categoryName"
                                                header="Category"
                                                body={categoryRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventName"
                                                header="Level"
                                                body={levelRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="genderName"
                                                header="Gender"
                                                body={genderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="formatName"
                                                header="Format"
                                                body={formatRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventLocation"
                                                header="Location"
                                                body={locationRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventCountryId"
                                                header="Country"
                                                body={countryRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventStartDate"
                                                header="Start Date"
                                                body={startDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventEndDate"
                                                header="End Date"
                                                body={endDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extcomRemarks"
                                                header="Remarks"
                                                body={remarksRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExternalCompetitions;